<div class="map-table-content">
  <div class="row">
    <div class="col">
      <div class="d-flex flex-row">
        <div class="d-inline-flex align-items-center">
          <mat-button-toggle-group
            *ngIf="groupButtons && groupButtons.length > 1"
            #group="matButtonToggleGroup"
            (change)="getInitTableFromName($event)"
            name="button-toggle-group"
            aria-label="table tabs"
            class="button-toggle-group"
            value="{{ selectedButton }}"
          >
            <mat-button-toggle [ngClass]="'px-2 width-fit'" [value]="btn.name" *ngFor="let btn of groupButtons">
              <mat-icon class="mr-1 me-1">
                {{ btn.icon }}
              </mat-icon>

              <span class="text-capitalize-first">{{ btn.label }}</span>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div class="p-2 ms-auto">
          <button mat-button [matMenuTriggerFor]="menu">
            <mat-icon>download</mat-icon>
            {{ 'map.map_table.export' | translate }}
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="export('pdf')">
              {{ 'map.map_table.export_pdf' | translate }}
            </button>
            <button mat-menu-item (click)="export('csv')">
              {{ 'map.map_table.export_csv' | translate }}
            </button>
            <button mat-menu-item (click)="export('excel')">
              {{ 'map.map_table.export_excel' | translate }}
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="currentTab" class="p-3 row">
    {{ currentTab.tab_description }}
  </div>

  <div class="py-3">
    <mtx-grid
      [data]="dataGrid"
      [columns]="columnsGrid"
      [showColumnMenuHeader]="false"
      [headerTemplate]="headerTpl"
      [hidePageSize]="true"
      [noResultText]="'common.no_result' | translate"
      [showFirstLastButtons]="false"
      [rowStriped]="true"
      [showPaginator]="false"
      [emptyValuePlaceholder]="'-'"
      [pageSize]="limit"
      [rowClassFormatter]="rowClassFormatter"
    >
    </mtx-grid>

    <ng-template #headerTpl let-col>
      <ng-container *ngIf="col.field === 'geometry'; else defaultHeader">
        <button mat-icon-button color="primary">
          <mat-icon>place</mat-icon>
        </button>
      </ng-container>
      <ng-template #defaultHeader>
        {{ col.header }}
      </ng-template>
    </ng-template>

    <ng-template #geometryColTemplate let-row>
      <button mat-icon-button color="primary" (click)="centerMapPlace(row)">
        <mat-icon>place</mat-icon>
      </button>
    </ng-template>
  </div>
</div>
